const DROPDOWN_PORTAL_ROOT_ID = 'wps-dropdown-portal-root'

/** Top-layer mount point for portaled dropdown menus (above app layout / cards). */
export function getDropdownPortalRoot(): HTMLElement {
  if (typeof document === 'undefined') {
    throw new Error('getDropdownPortalRoot requires a browser document')
  }
  let root = document.getElementById(DROPDOWN_PORTAL_ROOT_ID)
  if (!root) {
    root = document.createElement('div')
    root.id = DROPDOWN_PORTAL_ROOT_ID
    root.setAttribute('data-testid', DROPDOWN_PORTAL_ROOT_ID)
    root.style.position = 'fixed'
    root.style.inset = '0'
    root.style.zIndex = '999999'
    root.style.pointerEvents = 'none'
    root.style.overflow = 'visible'
    document.body.appendChild(root)
  }
  return root
}
